module.exports = __webpack_public_path__ + "static/media/Cactus_in_the_Desert.1026d749.png";